import { ANALYTICS_KEY } from '../../constants.js';
import '../../ui/Div/index.js';
import '../../ui/Link/index.js';
import { Text } from '../../ui/Text.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { Div } from '../../ui/Div/Div.js';
import { Link } from '../../ui/Link/Link.js';
function TrapdoorDescriptionColumn({
  header,
  subhead,
  labelCta,
  url
}) {
  return /*#__PURE__*/jsxs(Div, {
    flexDirection: "column",
    maxWidth: 320,
    flexGrow: 1,
    children: [/*#__PURE__*/jsx(Text, {
      variant: "headline",
      as: "h4",
      children: header
    }), /*#__PURE__*/jsx(Text, {
      variant: "body",
      as: "p",
      spacingTop: 1,
      children: subhead
    }), labelCta && url && /*#__PURE__*/jsx(Div, {
      spacingTop: 3,
      children: /*#__PURE__*/jsx(Link, {
        href: url,
        title: labelCta,
        color: "primary",
        variant: "headline",
        "data-qa": ANALYTICS_KEY.TrapDoorLabel,
        children: labelCta
      })
    })]
  });
}
export { TrapdoorDescriptionColumn };
//# sourceMappingURL=TrapdoorDescriptionColumn.js.map
